import {
  CrewMember,
  PersonaType,
  CrewMemberAssignment,
  WorkPackage,
  CrewMemberShiftType,
  OwnershipType,
  Scalars,
} from '@bechtel/types';

export interface AssignWorkOwnerProps {
  onClose: () => void;
  assignedCrewMembers: CrewMemberAssignment[];
  secondaryOwners: CrewMemberAssignment[];
  otherOwners: CrewMemberAssignment[];
  workPackages: WorkPackage[];
  isPlanningModule?: Scalars['Boolean'];
}

//TODO : Revisit interface after appropriate type is introduced in types
export interface AssignWorkPackageInput {
  crewMemberId: CrewMember['id'];
  workPackageId?: WorkPackage['id'];
  persona?: PersonaType;
  ownerType?: OwnershipType;
  shiftType?: CrewMemberShiftType;
  editedCrewMember?: CrewMember;
  deletePlan: boolean;
  isMultiOwnerEdit?: boolean;
}

export interface OwnerListProps {
  assignedCrewMembers: CrewMemberAssignment[];
  canEditSuperintendent: boolean;
  canEditGeneralForeman: boolean;
  canEditForeman: boolean;
  canEditFieldEngineer: boolean;
  onChange: (editedCrewMembers: CrewMemberAssignment[], supervisorId: CrewMember['id'] | null) => void;
}

export enum WorkOwnerType {
  'PRIMARY' = 'PRIMARY',
  'SECONDARY' = 'SECONDARY',
  'OTHER' = 'OTHER',
}
